<template>
  <ModalMain>
    <template #fullBody>
      <div class="p-modal-completed-thanks-point-send">
        <div class="p-modal-completed-thanks-point-send__inner">
          <div class="p-modal-completed-thanks-point-send__header">
            <p class="p-modal-completed-thanks-point-send__heading">
              {{ headingText }}
            </p>
          </div>
          <div class="p-modal-completed-thanks-point-send__body">
            <div class="p-modal-completed-thanks-point-send__body__image">
              <IconBalloonPresentBox
                class="
                  p-modal-completed-thanks-point-send__body__balloon
                  p-modal-completed-thanks-point-send__body__balloon--l
                "
                :size="balloonIconSize"
              />
              <IconUserImage  v-if="!isMultiGift" :size="profileIconSize">
                <img :src="icon" alt />
              </IconUserImage>
              <IconBalloonPresentBox
                class="
                  p-modal-completed-thanks-point-send__body__balloon
                  p-modal-completed-thanks-point-send__body__balloon--r
                "
                :size="balloonIconSize"
              />
            </div>

            <div v-if="!isMultiGift"
              class="p-modal-completed-thanks-point-send__body__name">
              <span
                class="p-modal-completed-thanks-point-send__body__name__text"
                data-translate-skip
                >{{ name }}</span
              >
            </div>
            <div v-if="isMultiGift"
              class="p-modal-completed-thanks-point-send__body__name">
              <span>
                {{ modalCompleteData.selectedUserCount }}名へ送付しました
              </span>
            </div>

            <div class="p-modal-completed-thanks-point-send__body__point">
              <PointNotation
                :point="sendPoint"
                :icon-size="32"
                :sign-is-exists="false"
              />
            </div>

            <div class="p-modal-completed-thanks-point-send__body__date">
              <p>
                <SmallText :size="14" color="#333333">{{ date }}</SmallText>
              </p>
              <p>
                <SmallText :size="14" color="#333333">
                  <slot name="text"
                    >現在、{{
                      thanksPointName
                    }}は承認待ちです。承認結果はポイント確認ページからご確認いただけます。</slot
                  >
                </SmallText>
              </p>
            </div>
          </div>
          <div class="p-modal-completed-thanks-point-send__footer">
            <ButtonMain
              class="p-modal-completed-thanks-point-send__button"
              tag="a"
              kind="secondary"
              :href="urlPointConfirmation"
              >ポイント確認ページを見る</ButtonMain
            >
            <ButtonMain
              class="p-modal-completed-thanks-point-send__button"
              tag="button"
              kind="cancel"
              @click-button="closeModal"
              >閉じる</ButtonMain
            >
          </div>
        </div>
      </div>
    </template>
  </ModalMain>
</template>

<script lang="ts">
import { mapActions, mapState } from "vuex";
import ModalMain from "@/common/components/organisms/ModalMain.vue";
import PointNotation from "@/common/components/atoms/PointNotation.vue";
import SmallText from "@/common/components/atoms/SmallText.vue";
import ButtonMain from "@/common/components/atoms/ButtonMain.vue";
import IconUserImage from "@/common/components/icons/IconUserImage.vue";
import IconBalloonPresentBox from "@/common/components/icons/IconBalloonPresentBox.vue";
import { Options, Vue } from "vue-class-component";
import modalState from "@/common/store/modules/modalState";
import globals from "@/general/store/modules/globals";
import commons from "@/common/store/modules/commons";
import { getThanksPointName } from "@/common/assets/js/utils/pointName";
import CONST_DATA from "@/general/mixins/const/constData";
import LocalStorage from "@/general/utils/storage";
@Options({
  emits: ["close"],
  props: {
    modalCompleteData: { type: [Object, Boolean], default: false },
    heading: { type: String, default: "サンクスポイントを送付しました" }
  },
  components: {
    ModalMain,
    PointNotation,
    SmallText,
    ButtonMain,
    IconUserImage,
    IconBalloonPresentBox
  },
  ...mapState({
    colorCode: () => commons.colorCode
  })
})
export default class ModalCompletedThanksPointSend extends Vue {
  modalCompleteData: any;
  heading!: string;

  get urlPointConfirmation() {
    return CONST_DATA.SITE_MAP.POINT_CONFIRMATION;
  }

  get headingText() {
    return this.heading;
  }

  get icon() {
    return this.modalCompleteData?.sendTo?.icon?.medium || "";
  }

  get name() {
    return this.modalCompleteData.sendTo.name;
  }

  get sendPoint() {
    return this.modalCompleteData.sendPoint;
  }

  get date() {
    const date = new Date();
    const formatedDate =
      date.getFullYear().toString() +
      "年" +
      (date.getMonth() + 1).toString() +
      "月 " +
      date.getDate().toString() +
      "日 " +
      ("0" + date.getHours()).slice(-2).toString() +
      ":" +
      ("0" + date.getMinutes()).slice(-2).toString();
    return formatedDate;
  }

  get profileIconSize() {
    const isSpScreenWidth = globals.isSpScreenWidth;
    return isSpScreenWidth ? 80 : 144;
  }

  get balloonIconSize() {
    const isSpScreenWidth = globals.isSpScreenWidth;
    return isSpScreenWidth ? 70 : 100;
  }

  get thanksPointName() {
    return getThanksPointName(CONST_DATA.POINT_NAME.THANKS_POINT_DEFAULT_NAME1);
  }

  closeModal() {
    this.$emit("close");
  }

  get isMultiGift() {
    return (
      this.modalCompleteData &&
      this.modalCompleteData.selectedUserCount > 1
    );
  }

}
</script>

<style lang="scss" scoped>
.p-modal-completed-thanks-point-send {
  @include pc {
    width: rem(540);
    padding: rem(56) 0 rem(48);
  }
  @include sp {
    width: rem(290);
    padding: rem(40) 0 rem(36);
  }
  background-color: $common-white;
  border-radius: rem(4);

  &__inner {
    @include pc {
      width: rem(397);
    }
    @include sp {
      width: rem(258);
    }
    margin: 0 auto;
  }

  &__header {
  }

  &__heading {
    @include pc {
      font-size: rem(24);
    }
    @include sp {
      font-size: rem(16);
    }
    text-align: center;
    font-weight: bold;
  }

  &__body {
    @include pc {
      margin-top: rem(48);
    }
    @include sp {
      margin-top: rem(24);
    }

    &__image {
      width: 100%;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    &__balloon {
      display: block;
      position: absolute;

      &--l {
        @include pc {
          top: rem(35);
          transform: rotate(-15deg);
        }
        @include sp {
          top: rem(20);
          transform: rotate(-20deg);
        }
        left: 0;
      }

      &--r {
        @include pc {
          transform: rotate(20deg);
        }
        @include sp {
          transform: rotate(15deg);
        }
        top: 0;
        right: 0;
      }
    }

    &__name {
      @include pc {
        margin-top: rem(16);
      }
      @include sp {
        margin-top: rem(8);
      }
      text-align: center;

      &__text {
        @include pc {
          font-size: rem(16);
        }
        @include sp {
          font-size: rem(14);
        }
        font-weight: bold;
      }
    }

    &__point {
      @include pc {
        margin-top: rem(8);
      }
      @include sp {
        margin-top: rem(4);
      }
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &__date {
      @include pc {
        margin-top: rem(24);
      }
      @include sp {
        margin-top: rem(16);
      }
      max-width: rem(240);
      margin: 0 auto;
      text-align: center;

      p + p {
        margin-top: 1.5em;
      }
    }
  }

  &__footer {
    @include pc {
      padding-top: rem(40);
    }
    @include sp {
      padding-top: rem(32);
    }
    max-width: rem(240);
    margin: 0 auto;
  }

  &__button {
    & + & {
      margin-top: rem(16);
    }
  }
}
</style>
